"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorable_1 = require("../../abstract/colorable");
const undirectedEdge_1 = require("./undirectedEdge");
class WeightedUndirectedEdge extends undirectedEdge_1.UndirectedEdge {
    constructor() {
        super(...arguments);
        this.weight = 0;
        this.unit = "";
    }
    draw(ctx, grid) {
        super.draw(ctx, grid);
        this.drawWeight(ctx, grid);
    }
    drawWeight(ctx, grid) {
        let fromCoord = grid.getCoordinate(this.startNode);
        let toCoord = grid.getCoordinate(this.endNode);
        ctx.restore();
        ctx.save();
        let dx = Math.abs(toCoord[1] - fromCoord[1]);
        let dy = Math.abs(toCoord[0] - fromCoord[0]);
        let trd = Math.sqrt(dx * dx + dy * dy) / 10;
        let mid = [((toCoord[1] + fromCoord[1]) / 2),
            ((toCoord[0] + fromCoord[0]) / 2)];
        ctx.translate(mid[0], mid[1]);
        let textSize = 5 * grid.getNodeHeight() / 9;
        ctx.font = 'normal ' + textSize + 'px Arial';
        ctx.textAlign = "center";
        if (colorable_1.Colorable.isColorable(this)) {
            ctx.fillStyle = this.getColor();
        }
        ctx.fillText(this.getWeight() + "" + this.unit, (dy >= dx) ? textSize : 0, (dy >= dx) ? 0 : textSize);
        ctx.restore();
    }
    setWeight(weight) {
        this.weight = weight;
    }
    getWeight() {
        return this.weight;
    }
    setUnit(unit) {
        this.unit = unit;
    }
    getUnit() {
        return this.unit;
    }
}
exports.WeightedUndirectedEdge = WeightedUndirectedEdge;
